
























import {Component, Vue} from "vue-property-decorator";
import FlashMessage from "@/app/models/FlashMessage";
import BaseLayout from "@/resources/layouts/BaseLayout.vue";

@Component({
    components: { BaseLayout }
})
export default class App extends Vue {
    get all(): string[] {
        return this.$root.messages.map((flash: FlashMessage): string => flash.message);
    }
}
